import { createIcon } from "@hopper-ui/icons";
import type { ComponentProps, FunctionComponent } from "react";

export function createIconFromSingleSize(iconType: FunctionComponent<ComponentProps<"svg">>, displayName: string) {
    const factory = (size: number) => {
        return (props: ComponentProps<"svg">) => iconType({ width: size, height: size, ...props });
    };

    return createIcon(factory(16), factory(24), factory(32), displayName);
}
